import React, { useId, useState } from 'react';
import './AddressLink.css';

const ADDRESS_LINES = ['Alte Bandfabrik 1', '7053 Hornstein', 'Österreich'];
const GOOGLE_MAPS_URL = 'https://www.google.com/maps/search/?api=1&query=Alte+Bandfabrik+1,+7053+Hornstein,+Österreich';
const APPLE_MAPS_URL = 'http://maps.apple.com/?address=Alte+Bandfabrik+1,7053,Hornstein,Österreich';

const AddressLink = ({ label, variant = 'full', className = '' }) => {
  const [open, setOpen] = useState(false);
  const menuId = useId();

  const handleToggle = () => setOpen((prev) => !prev);
  const handleClose = () => setOpen(false);

  const defaultLabel =
    label ??
    ADDRESS_LINES.map((line, index) => (
      <React.Fragment key={line}>
        {line}
        {index < ADDRESS_LINES.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <div
      className={`address-link address-link--${variant} ${className}`}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
          setOpen(false);
        }
      }}
    >
      <button
        type="button"
        aria-expanded={open}
        aria-controls={menuId}
        className="address-link__button"
        onClick={handleToggle}
      >
        <span className="address-link__label">{defaultLabel}</span>
      </button>
      {open && (
        <div
          className={`address-link__menu ${
            variant === 'inline' ? 'address-link__menu--up' : ''
          }`}
          id={menuId}
          role="menu"
        >
          <a
            href={GOOGLE_MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            role="menuitem"
            onClick={handleClose}
          >
            Google Maps öffnen
          </a>
          <a
            href={APPLE_MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            role="menuitem"
            onClick={handleClose}
          >
            Apple Karten öffnen
          </a>
        </div>
      )}
    </div>
  );
};

export default AddressLink;
